import { useTranslation } from "react-i18next";

import { FavoritesList } from "../features/favorites/FavoritesList";

export function FavoritesRoute() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-3xl px-4 py-6">
      <h1 className="mb-4 text-2xl font-bold text-fg">{t("favorites.title")}</h1>
      <FavoritesList />
    </div>
  );
}
